import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { setOverlayValue } from 'store';
import WP from 'WP';

import BookATable from './BookATable';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import SmartLink from 'partials/SmartLink';
import Button from 'partials/Button';
import FavoriteButton from 'partials/FavoriteButton';

import Media from 'css/Media';

const BookingInfo = props => {
    
    const handleOnClick = () => {
        props.setOverlayValue({
            visible: true, 
            component: <BookATable src={props.src} />
        })
    }

    const { data, phone, link, isMobile } = props;

    return (
        <Wrapper>
            <Container grid>
                <StyledGridElement 
                    colStart={{default: 1, s: 7}} 
                    colEnd={{default: 8, s: 18}}
                >
                    { data.acf.has_bookatable &&
                        <StyledButton onClick={() => handleOnClick()}>{WP.trans.reserveTable}</StyledButton>
                    }
                    { !isMobile && !data.acf.has_bookatable &&
                        <Contact><SmartLink to={'mailto:' + data.acf.contact_adress}>{data.acf.contact_adress}</SmartLink></Contact>
                    }
                    { !isMobile &&
                        <Contact>
                            <a id="phonenumber" href={`tel: ${phone}`}>{phone}</a>
                            <SmartLink to={link.url} target="_blank">{link.title}</SmartLink>
                        </Contact>
                    }
                    { isMobile &&
                        <Contact>
                            { !data.acf.has_bookatable &&
                                <React.Fragment>
                                    <StyledSmartLink to={'mailto:' + data.acf.contact_adress}>{data.acf.contact_adress.toUpperCase()}</StyledSmartLink>
                                    <span>•</span>
                                </React.Fragment>
                            }
                            <span><a href={`tel: ${phone}`}>{phone}</a></span>
                            <span>•</span>
                            <SmartLink to={link.url} target={link.target}>{link.title.toUpperCase()}</SmartLink>
                            <MobileFavoriteButton item={data} sort={data.type} />
                        </Contact>
                    }
                    { !isMobile &&
                        <FavoriteButton item={data} sort={data.type} />
                    }
                </StyledGridElement>
            </Container>
        </Wrapper>
    )
}

const actions = {
    setOverlayValue,
};

export default connect(null, actions)(BookingInfo);

const Wrapper = styled.div`
`

const StyledGridElement = styled(GridElement)`
    display: flex;
    flex-direction: column-reverse;

    ${Media.greaterThan('s')`
        align-items: center;
        flex-direction: row;
    `}
`

const StyledButton = styled(Button)`
    width: 100%;
    padding: ${props => props.theme.spacing.contentS};
    margin-right: ${props => props.theme.spacing.elementXS};

    ${Media.greaterThan('s')`
        max-width: ${props => props.theme.spacing.blockXL};
    `}
`

const Contact = styled.div`
    display: flex;
    margin-bottom: ${props => props.theme.spacing.contentL};

    #phonenumber {
        white-space: nowrap;
        margin-right: 6px;
        text-decoration: none;
    }

    span {
        white-space: nowrap;
        margin-right: 6px;
    }

    a {
        color: ${props => props.theme.colors.link};
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }

    ${Media.greaterThan('s')`
        margin-right: ${props => props.theme.spacing.elementM};
        margin-bottom: 0;

        span {
            margin-right: ${props => props.theme.spacing.elementXS};
        }
    `}

    ${Media.lessThan('m')`
        align-items: center;
        
        >div {
            height: auto;
        }

        span, a {
            font-size: 12px;
        }
    `}
`

const MobileFavoriteButton = styled(FavoriteButton)`
    margin: 0 0 0 auto;
`

const StyledSmartLink = styled(SmartLink)`
    margin-right: 6px;
`